export const FETCH_ACCOUNT_CODES_ERROR = 'FETCH_ACCOUNT_CODES_ERROR';
export const FETCH_ACCOUNT_CODES_REQUEST = 'FETCH_ACCOUNT_CODES_REQUEST';
export const FETCH_ACCOUNT_CODES_SUCCESS = 'FETCH_ACCOUNT_CODES_SUCCESS';

export default {
  FETCH_ACCOUNT_CODES_ERROR,
  FETCH_ACCOUNT_CODES_REQUEST,
  FETCH_ACCOUNT_CODES_SUCCESS,
};
